import { ProductCard } from '@/widgets/ProductCard'

import { TProduct } from '@/shared/types/product-types'

import cl from './GridWithBannerSection.module.scss'

export type ObserverListProps = {
	items: TProduct[]
}

export const GridWithBannerSection = (props: ObserverListProps) => {
	const { items } = props

	// Фильтруем элементы, у которых есть поле SECTION_NAME
	const filteredItems = items?.filter(item => item.SECTION_NAME)

	return (
		<>
			{filteredItems?.map(item => (
				<div className={cl.card} key={item.KOD}>
					<ProductCard data={item} noFastOrder={true} adaptive={true} />
				</div>
			))}
		</>
	)
}
